import React, { useEffect, useRef } from 'react'
import { COPY_STRINGS } from '../../../../constants/translatedCopy';
import { PRE_CHECK_MACHINE_STATES } from '../../constants';
import useStudentPreChecks from '../../useStudentPreChecks';
import { MS_FOR_OVERALL_TIMEOUT_FTUE, MS_FOR_OVERALL_TIMEOUT_RETURNING_USER_ASSESSMENT } from '../StudentVolumeChecksConstants';
import { getCopyByGradeband } from '../../../../services/ThemingService';

export default function VolumeOverallTimer(props) {

  const { speechProps, setShowTeacherTroubleshootScreen, volumeStats, studentSpeechVolumeEvaluationCount, logVolumeCheckFailure } = props

  const studentPreCheck = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks });
  const { settings } = studentPreCheck;

  const overallCheckTimer = useRef() // the whole check is expected to be done within

  useEffect(() => {
    startOverallCheckTimer()

    return () => {
      cancelOverallCheckTimer()
      speechProps.abortSpeech()
    }
  }, [])

  const startOverallCheckTimer = () => {
    cancelOverallCheckTimer() // cancel existing one first if exists
    const timerMS = !settings.shouldGoThroughFTUE ?
      MS_FOR_OVERALL_TIMEOUT_RETURNING_USER_ASSESSMENT :
      MS_FOR_OVERALL_TIMEOUT_FTUE

    overallCheckTimer.current = setTimeout(() => {
      handleOverallTimeoutEvent()
    }, timerMS)
  }

  const cancelOverallCheckTimer = () => {
    if (overallCheckTimer.current) {
      clearTimeout(overallCheckTimer.current)
      overallCheckTimer.current = null
    }
  }

  const handleOverallTimeoutEvent = async () => {
    await speechProps.speakWithPromise({
        textToSpeak: getCopyByGradeband(COPY_STRINGS, 'student_checks').handle_get_teacher
    })
    
    studentPreCheck.addTroubleshootData({
      ready_handle_overall_timeout: {
        volumeSnapshot: volumeStats,
        trialCount: studentSpeechVolumeEvaluationCount.current
      }
    })
    
    logVolumeCheckFailure('OVERALL_TIMEOUT', {
      trialCount: studentSpeechVolumeEvaluationCount.current,
      volumeStats: volumeStats,
      timeoutMs: !settings.shouldGoThroughFTUE ? MS_FOR_OVERALL_TIMEOUT_RETURNING_USER_ASSESSMENT : MS_FOR_OVERALL_TIMEOUT_FTUE
    });
    
    setShowTeacherTroubleshootScreen(true)
  }

  return null
}
